import { Component, Input, OnInit } from '@angular/core';
import { SupportService } from 'src/app/services/core/support/support.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
import { OnboardingMenu, UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { JotformService } from 'src/app/services/core/jotform/jotform.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { downloadBlobFile } from 'src/app/utils/pdf-downloader';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css']
})
export class VehiclesComponent implements OnInit {

  @Input() companyId:any;
  vehicleModalObj:any;
  vehicleEditModalObj:any;
  search:any;
  vehicles = [];
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  filteredVehicleList:any = [];
  spacetypes:any;
  preSpacetypes:any = {};
  status:boolean = true;
  userPermission=UserPermission
  loading: any = null;
  logObj:any;
  selectedDropdownIndex:any;
  toggleActionButtons = false;
  private readonly searchSubject = new Subject<string | undefined>();
  
  constructor(
    private supportService: SupportService,
    private spaceTypeService : SpaceTypeService,
    private cedentialService : CredentialService,
    private jotformService: JotformService,
    public permissionService: PermissionService,
    private sharedDataService: SharedDataService
  ){}

  ngOnInit(){
    this.getRedirectEntity();
    this.getSpaceType();
    this.getCompanyWiseVehicles(this.currentPage);
    this.initializeSearch();
  }

  getRedirectEntity() {
    this.sharedDataService
      .getOnboardingRedirectEntity()
      .pipe(untilDestroyed(this))
      .subscribe((redirect) => {
      if (redirect) {
        const {entity, entityType} = redirect;
        if (entity && entityType === OnboardingMenu.VEHICLES) {
          this.openVehicleModal(entity);
          this.companyId = entity.company
          this.search = entity.vin;
          this.status = entity.isActive;
          this.searchSubject.next(this.search);
          this.sharedDataService.setOnboardingRedirectEntity(null);
        }
      }
    });
  }

  getCompanyWiseVehicles(page:number){
    let queryParams: any = {
      limit : 50,
      page,
      isActive : this.status
    }
     if (this.search) {
      queryParams.search = this.search.trim();;
    }
    this.cedentialService.getVehicles(this.companyId, queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data && data.results){
        this.vehicles = data.results;
        this.vehicles = data.results.sort((a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        this.filteredVehicleList = [...this.vehicles]
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    })
  }

  openVehicleModal(vehicle:any){
   this.vehicleModalObj = vehicle;
  }
  
  onPageChange(page: number) {
    this.currentPage = page;
    this.getCompanyWiseVehicles(page);
  }

  onSelectStatus(){
   this.getCompanyWiseVehicles(this.currentPage = 1)
  }

  getSpaceType() {
    const queryParams = {
      isActive: true,
      limit: 9999
    }
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypes = data.results;
        this.preSpacetypes = this.spacetypes.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
     
      }
    })
  }

   onSyncData(id: any) {
    this.loading = id;
    this.cedentialService.onSyncData(id,'vehicles').subscribe({
      next: (data: any) => {
        sweetAlert('Success', 'Vehicle Synced Successfully!', 'success', 'OK');
        this.getCompanyWiseVehicles(this.currentPage);
      },
      error: (err: any) => {
        sweetAlert('Error', err, 'error', 'OK');
      },
      complete: () => {
        this.loading = null;
      }

    })
  }

  onVehicleStatusUpdated(updatedVehicle: any) {
    if (!updatedVehicle) {
      this.vehicleModalObj = null;
      return;
    }
    this.vehicleModalObj.isApproved = updatedVehicle.isApproved;

  }

  openVehicleEditModal(vehicle: any) {
    this.vehicleEditModalObj = vehicle;
  }

  onSaveVehicle(evt: any) {
    if (evt) {
      const idx = this.filteredVehicleList.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.filteredVehicleList[idx] = evt;
      } else {
        this.filteredVehicleList.splice(idx, 1);
      }
    }
    this.vehicleEditModalObj = null;
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3) 
      ).subscribe(() => {
        this.currentPage = 1;
        this.getCompanyWiseVehicles(this.currentPage)
      });
  }

    onSearchInput() {
    this.searchSubject.next(this.search);
  }

  onCloseVehicleModal() {
    this.vehicleEditModalObj = null;
  }

  showActionButtons(idx:any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }
  raiseTicket(vehicle: any) {
    this.supportService.raiseTicket('vehicle', vehicle.id);
  }

  openLogModal(vehicle:any){
    this.logObj = vehicle.id;
  }

  onDownloadInspectionForm(vehicle: any) {
    if (!vehicle?.vin) {
      sweetAlert('Error', 'Vehicle VIN is required to download the inspection form.', 'warning', 'OK');
      return;
    }

    this.jotformService.downloadInspectionPdf(vehicle.vin).pipe(untilDestroyed(this)).subscribe({
      next: (data) => {
        downloadBlobFile(new Blob([data], { type: 'application/pdf' }), `inspection_${vehicle.vin}.pdf`);
      },
      error: (err: any) => {
        sweetAlert('Error', err || 'Failed to download inspection form.', 'warning', 'OK');
      },
    });
  }
}
